import type { AdvisorFieldsType } from "../types"

export const mapParamToValue = <T,>(
  path: AdvisorFieldsType,
  paramMap: Record<string, (basePath: string) => T>,
) => {
  const param = path.split(".").slice(-1)[0]
  const basePath = path.split(".").slice(0, -1).join("/")
  return paramMap[param](basePath)
}
